import React from 'react';

export default function Toast({ icon, title, subtitle }) {
  return (
    <div className="toast">
      <span className="toast-icon">{icon}</span>
      <div>
        <div className="toast-title">{title}</div>
        <div className="toast-sub">{subtitle}</div>
      </div>
    </div>
  );
}
